import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { ValidateSuperSignInDto } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-super-signin',
  templateUrl: './super-signin.component.html',
  styleUrls: ['./super-signin.component.scss']
})
export class SuperSigninComponent implements OnInit {
  @ViewChild('content') modalContent: string;
  username: string;
  token: string;
  superSigninToken: string;

  constructor(
    private accountService: AccountService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private toastService: HotToastService,
    private router: Router,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.username = this.route.snapshot.params.username;
    this.token = this.route.snapshot.params.token;
    this.superSigninToken = this.route.snapshot.params.supersignintoken;
    const request: ValidateSuperSignInDto = {
      email: this.username,
      superSignInToken: this.superSigninToken,
    };
    this.accountService.validateSuperSignin(request).subscribe(
      () => {
        const auth: AuthModel = {
          access_token: this.token,
          token_type: 'bearer',
          expires_in: 604800, // one week
          email: this.username,
        };
        this.authenticationService.setAuthentication(auth, this.username);
        this.router.navigate(['my-account']);

      },
      (error: HttpErrorResponse) => {
        this.modalService.open(this.modalContent);
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }
}
